import { getDomainUrl } from 'core/utils';

export const manufacturersPath = () => '/manufacturers';
export const configuratorsPath = () => '/configurators';
export const elementsPath = () => '/elements';
export const companyPartsPath = () => '/company/parts';
export const companyConfiguratorsPath = () => '/company/configurators';
export const companyElementsPath = () => '/company/elements';

const domainUrl = getDomainUrl();

export const oldPartPath = (partNumber: string, manufacturerName: string) =>
  `${domainUrl}/part_v2?number=${partNumber}&manufacturer=${manufacturerName}`;
export const oldPartsPath = (query = '') => `${domainUrl}/part_v2/search?q=${query}`;
export const oldManufacturersPath = () => `${domainUrl}/manufacturers/list`;
export const oldConfiguratorsPath = () => `${domainUrl}/configurator/list`;
export const oldElementsPath = () => `${domainUrl}/element/template/list`;
export const oldCompanyConfiguratorsPath = () => `${domainUrl}/bom/list/all`;
export const oldCompanyElementsPath = () => `${domainUrl}/element/template/list`;
